var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20634",
    "data-name": "Group 20634",
    transform: "translate(-9006 3848.38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6454",
    "data-name": "Rectangle 6454",
    transform: "translate(9010 -3848.38)",
    fill: "none",
    stroke: "#363636",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 12,
    height: 12,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6455",
    "data-name": "Rectangle 6455",
    transform: "translate(9014 -3848.38)",
    fill: "none",
    stroke: "#363636",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H5A0,0,0,0,1,5,0V5A1,1,0,0,1,4,6H1A1,1,0,0,1,0,5V0A0,0,0,0,1,0,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 4,
    height: 5,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20635",
    "data-name": "Group 20635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6456",
    "data-name": "Rectangle 6456",
    transform: "translate(9006 -3834.38)",
    fill: "none",
    stroke: "#363636",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 5,
    height: 5,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6457",
    "data-name": "Rectangle 6457",
    transform: "translate(9021 -3834.38)",
    fill: "none",
    stroke: "#363636",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 5,
    height: 5,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6458",
    "data-name": "Rectangle 6458",
    transform: "translate(9013.5 -3834.38)",
    fill: "none",
    stroke: "#363636",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 5,
    height: 5,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1684",
    "data-name": "Line 1684",
    x2: 2.803,
    transform: "translate(9011.139 -3830.88)",
    fill: "none",
    stroke: "#363636",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1685",
    "data-name": "Line 1685",
    x2: 2.803,
    transform: "translate(9018.613 -3830.88)",
    fill: "none",
    stroke: "#363636",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesOrder);
export default __webpack_public_path__ + "static/media/Sales Order.252ac39d5922d7ccf7145241b1624f01.svg";
export { ForwardRef as ReactComponent };